import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AuthService from "../services/AuthService";
import ApiService from "../services/ApiService";
import { CiSearch } from "react-icons/ci";
import { LiaUserCircleSolid, LiaShoppingBagSolid } from "react-icons/lia";
import { MdOutlineArrowDropDown } from "react-icons/md";
import OtpInput from 'react-otp-input';
import { Container, Row, Col, Button, Form } from "react-bootstrap";

const VerifyOTP = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoader, setIsLoader] = useState(false);
  const navigate = useNavigate();
  const [otp, setOTP] = useState('');

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    setIsLoader(true);
    const user_id = localStorage.getItem('user_id');

    try {
      const response = await ApiService.request({
        method: "POST",
        url: "/verifyOTP",
        data: { otp, user_id },
      });

      if (response.data.status) {
        const { user, auth_token } = response.data.data;
        user.auth_token = auth_token;
        AuthService.setCurrentUser(user);
        toast.success(response.data.message);
        navigate("/add-address");
      } else {
        toast.error(response.data.message || "Login failed");
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("An error occurred during login");
    } finally {
      setIsLoader(false);
    }
  };

  return (
    <div className="header-banner bg-gradient" id="home">
      <div className="container">
        <div className="row">
          <div
            className="col-md-12 shadow main-heading"
            style={{ display: "flex", flexDirection: "column" }}
          >
            {/* Reused Header */}
            <div className="top-bar d-flex justify-content-between px-4 py-2">
              <div className="top-bar-left">
                <span className="text-secondary">Welcome</span>
                <p className="mb-0 text-base">Login to continue</p>
              </div>

              <div className="top-bar-right d-flex align-items-center">
                <Link to="/login">
                  <LiaUserCircleSolid className="top-bar-search-icon fs-2 mx-2 fw-semibold text-secondary" />
                </Link>
                <Link to="/cart">
                  <LiaShoppingBagSolid className="top-bar-search-icon fs-2 mx-2 fw-semibold text-secondary" />
                </Link>
                <CiSearch className="top-bar-search-icon fs-2 fw-bold" />
              </div>
            </div>

              {/* Verify OTP Form */}
                <div className="row">
                  <div className="tab col-md-6 col-12 mt-5 mx-auto  bg-white rounded border shadow p-4">
                    <div>
                      <h2  className=" fw-bold  mt-4 text-center"
                          style={{ fontSize: "25px" }} >
                          Verify OTP
                      </h2>

                      <p className="  text-center">
                          Enter the 4‑digit code we just sent to your phone.
                      </p>

                      <Form onSubmit={handleVerifyOTP} className=" w-100">
                          <div className=" d-flex gap-2 gap-md-4 mb-3 flex-wrap justify-content-center">
                              <OtpInput
                                  value={otp}
                                  onChange={(value) => setOTP(value)}
                                  numInputs={4}
                                  separator={<span>-</span>}
                                  renderInput={(props) => <input {...props} style={{ width:'50px',margin:'10px', borderRadius:'5px', border: '1px solid #ccc', padding: '8px', fontSize: '18px', textAlign:'center' }} />}
                              />
                          </div>

                          <div className=" d-flex justify-content-center mt-4">
                          <Button
                              type="submit"
                              className=" btn btn-base btn-lg mb-3 border-0"
                              disabled={isLoader}
                          >
                              {isLoader ? "Verifying…" : "Submit"}
                          </Button>
                          </div>
                      </Form>
                  </div>
                </div>


            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyOTP;